import { render, staticRenderFns } from "./AccountRemoved.vue?vue&type=template&id=a116d4a6&scoped=true&"
import script from "./AccountRemoved.vue?vue&type=script&lang=js&"
export * from "./AccountRemoved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a116d4a6",
  null
  
)

export default component.exports